const SHORT_LINKS_URLS = {
  dev: 'https://dev.chied.info/l',
  prod: 'https://chied.info/l',
};

const getShortLinkBaseUrl = () => {
  return SHORT_LINKS_URLS[process.env.REACT_APP_ENVIRONMENT];
};

export default getShortLinkBaseUrl;
